export default __webpack_public_path__ + "static/media/edit.c4aff373.svg";